/**
 * The per-module progress bar in the sidebar. Chrome only — the sidebar is a
 * fixed palette in both panel modes, so nothing here is conditional.
 */
export function ProgressBar({ completed, total }) {
  const pct = total === 0 ? 0 : Math.round((completed / total) * 100);
  return (
    <div style={{ padding: "0 10px 8px 22px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
        <span style={{ fontSize: 11, color: "var(--chrome-muted)", letterSpacing: "0.5px", textTransform: "uppercase" }}>Progress</span>
        <span style={{ fontSize: 11, color: "var(--chrome-accent)", fontWeight: 600 }}>{pct}%</span>
      </div>
      <div style={{ height: 3, background: "var(--chrome-border)", borderRadius: 4, overflow: "hidden" }}>
        <div style={{
          height: "100%", width: `${pct}%`, borderRadius: 4,
          background: "linear-gradient(90deg, var(--chrome-accent-solid), var(--chrome-accent))",
          transition: "width 0.5s ease",
        }} />
      </div>
    </div>
  );
}
